<script setup lang="ts">
import { NodeViewWrapper } from "@tiptap/vue-3";
import { NodeViewProps } from "@tiptap/core";

const props = defineProps<NodeViewProps>();
</script>
<template>
  <node-view-wrapper :as="'span'">
    <span class="text-primary whitespace-pre-wrap">
      {{ node.attrs.text }}
    </span>
  </node-view-wrapper>
</template>
